import { styled } from '@mui/material';

import { focusRing, hoverable, theme } from '@/design-system';

const BANNER_HEIGHT = 220;

export const BannerRoot = styled('section')({
  position: 'relative',
  isolation: 'isolate',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  flexShrink: 0,
  height: `${BANNER_HEIGHT}px`,
  padding: `${theme.spacing[8]}px`,
  borderRadius: `${theme.radius[12]}px`,
  backgroundColor: theme.colors.background.raised,
});

export const Glow = styled('span')({
  position: 'absolute',
  zIndex: -2,
  left: '-78px',
  top: '-34px',
  pointerEvents: 'none',
});

export const PhoneFrame = styled('span')({
  position: 'absolute',
  zIndex: -1,
  right: '-11px',
  bottom: '-15px',
  width: '195px',
  height: '179px',
  overflow: 'hidden',
  pointerEvents: 'none',
});

export const PhoneImage = styled('img')({
  position: 'absolute',
  left: 0,
  top: '-19.99%',
  width: '126.15%',
  height: '178.53%',
  maxWidth: 'none',
});

export const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: `${theme.spacing[8]}px`,
  width: '156px',
});

export const StoreLinks = styled('div')({
  display: 'flex',
  gap: `${theme.spacing[8]}px`,
});

export const StoreLink = styled('a')({
  display: 'flex',
  padding: `${theme.spacing[4]}px`,
  borderRadius: `${theme.radius[8]}px`,
  backgroundColor: theme.colors.white[8],
  ...hoverable(theme, 'surfaceStrong'),
  ...focusRing(theme),
});

export const CloseSlot = styled('div')({
  position: 'absolute',
  top: `${theme.spacing[4]}px`,
  right: `${theme.spacing[4]}px`,
});
